import Typography from '@material-ui/core/Typography'
import React from 'react'
import * as css from './Error.css'
import { useTranslation } from 'react-i18next'

export const ErrorContainer = props => {
  const { t } = useTranslation()
  return (
    <div className={css.message}>
      <Typography variant='subtitle1'>
        {t('messages.genericErrorMessage', 'Something went wrong')}
      </Typography>
    </div>
  )
}
